import { render, staticRenderFns } from "./livemain.vue?vue&type=template&id=6b28ec94&lang=pug&"
import script from "./livemain.vue?vue&type=script&lang=js&"
export * from "./livemain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports